
import { Entity } from '../base/entity';
import { Entry } from '../ui/entry';
import { Address } from './address';
import { KontaktOsoba } from './kontaktOsoba';

export class Partner extends Entity implements Entry {
     
    public static readonly TABLENAME = 'partner';
  	
    public static readonly ID = "id";
    public static readonly PARTNER_NAME = "partner_name";
    public static readonly SHORT_NAME = "short_name";
    public static readonly CODE = "code";
    public static readonly PARTNER_TYPE_ID = "partner_type_id";
    public static readonly CITY_ID = "city_id";
    public static readonly ADDRESS = "address";
    public static readonly PIB = "pib";
    public static readonly JBKJS = "jbkjs";
    public static readonly PAK = "pak";
    public static readonly PHONE = "phone";
    public static readonly EMAIL = "email";
    public static readonly VAT = "vat";
    public static readonly COMPANY_ID = "company_id";
    public static readonly MATICNI_BROJ = "maticni_broj";
    public static readonly REGISTER_NUMBER = "register_number";
    
    
    id: string;
    partnerName: string;
    shortName: string;
    code: string;
    partnerTypeId: number;
    pib: string;
    jbkjs: string;
    cityId: number;
    address: string;
    pak: string;
    phone: string;
    email: string;
    vat: boolean;
    companyId: string;
    maticniBroj: string;
    registerNumber: string;

    cityName: string;
    partnerId: string | null;

    ko: KontaktOsoba[] = [];
    adr: Address[] = [];
    
    public key(): any {
        return this.id;
    }

    public value(): any {
        return this.shortName;
    }
    
}
